<script setup lang="ts">
interface Props {
  compact?: boolean;
}

withDefaults(defineProps<Props>(), {
  compact: false,
});
</script>

<template>
  <div class="logo" :class="{ 'is-compact': compact }">
    <img
      v-if="compact"
      src="/images/logo-artech-symbol.svg"
      alt="Artech Admin"
      class="logo__icon"
    />
    <img
      v-else
      src="/images/logo-artech-horizontal.svg"
      alt="Artech"
      class="logo__icon"
    />
    <span v-if="!compact" class="logo__badge">Admin</span>
  </div>
</template>

<style scoped lang="scss">
.logo {
  display: inline-flex;
  align-items: center;
  gap: token("gap-xsmall");

  &__icon {
    height: 24px;
    width: auto;
  }

  &.is-compact &__icon {
    height: 24px;
    width: 24px;
  }

  &__badge {
    display: inline-flex;
    align-items: center;
    padding: 2px token("padding-2xsmall");
    border-radius: token("corner-radius-xsmall");
    background: token("color-bg-neutral-subtle");
    color: token("color-content-neutral-strong");
    text-transform: uppercase;
    letter-spacing: 0.08em;
    font-size: 10px;
    font-weight: 600;
    line-height: 1;
  }
}
</style>
